module.exports = {"130683001":"药都街道","130683002":"祁州路街道","130683101":"伍仁桥镇","130683102":"石佛镇","130683103":"郑章镇","130683104":"大五女镇","130683105":"西佛落镇","130683106":"西城镇","130683200":"明官店乡","130683201":"南娄底乡","130683204":"北段村乡","130683400":"现代中药工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130683.json
// module id = 263
// module chunks = 0